/** Custom event on window for the host (lifecycle, add-to-cart). */
export function dispatchHostEvent(eventName, detail) {
  if (typeof window === "undefined" || !eventName) return;
  window.dispatchEvent(new CustomEvent(eventName, { detail: detail ?? {} }));
}

/** Emits triggerTrackingEvent (GA4/PostHog). eventName short */
export function trackEvent({ eventName, eventType, action, details }) {
  const allowedTypes = ["Click", "View", "Submit", "Custom"];
  if (!eventName || !eventType || !action) {
    if (typeof window !== "undefined" && import.meta.env?.DEV) {
      console.warn(
        "[tracking] Missing required field: eventName, eventType, action",
      );
    }
    return;
  }
  if (!allowedTypes.includes(eventType)) {
    if (typeof window !== "undefined" && import.meta.env?.DEV) {
      console.warn("[tracking] eventType must be one of:", allowedTypes);
    }
    return;
  }

  const detail = { eventName, eventType, action };
  if (
    details != null &&
    typeof details === "object" &&
    Object.keys(details).length > 0
  ) {
    detail.details = details;
  }

  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("triggerTrackingEvent", { detail }));
  }
}
